export const clearCurrentTimeInterval = event => {
  const $video = event.currentTarget;
  clearInterval($video.currentTimeInterval);
};
